import { CommentList, CommentModal } from 'components'
import { useEffect, useState } from 'react'
import { useCommentList, useCommentRegist, useCommentUpdate, useCommentDelete } from 'api/common/cmnt-fetch'
import { useRecoilValue } from 'recoil'
import { userInfoState } from 'store/atom/user-state-atom'
import { isEmptyString } from 'utils/common-util'
import { queryClient } from 'index'

function Element({ ntcAtclId = '', setCount = () => {}, dispAuthor = true }) {
  const userInfo = useRecoilValue(userInfoState)

  const [comments, setComments] = useState([])
  const { data, refetch } = useCommentList(
    {
      coId: userInfo.coId,
      siteId: userInfo.siteId,
      lgsCtrId: userInfo.lgsCtrId,
      ntcAtclId: ntcAtclId,
    },
    false,
  )

  useEffect(() => {
    return () => {
      queryClient.removeQueries('commentList')
    }
  }, [])

  useEffect(() => {
    if (!isEmptyString(ntcAtclId)) {
      refetch()
    }
  }, [ntcAtclId])

  useEffect(() => {
    if (data) {
      reCommentList(data.data)
    }
  }, [data])

  const reCommentList = (comments) => {
    const temp = comments.filter((comment) => comment.hgrnkCmntId === null || comment.hgrnkCmntId === '')
    temp.map((item) => (item.replyList = comments.filter((comment) => item.cmntId === comment.hgrnkCmntId)))
    setComments(temp)
    const cmmtCnt = comments.filter((comment) => comment.useYn === 'Y' && comment.magrDelYn === 'N')
    setCount(cmmtCnt?.length)
  }

  const commentRegist = useCommentRegist({
    successHandler: () => {
      refetch()
    },
    errorHandler: () => {},
  })

  const commentUpdate = useCommentUpdate({
    successHandler: () => {
      refetch()
    },
    errorHandler: () => {},
  })

  const commentDelete = useCommentDelete({
    successHandler: () => {
      refetch()
    },
    errorHandler: () => {},
  })

  return (
    <>
      <div style={{ marginBottom: '54px' }}>
        {comments.map((comment, index) => (
          <CommentList
            className="mt24"
            comment={comment}
            dispAuthor={dispAuthor}
            key={`comment_${index}`}
            registMutation={commentRegist}
            updateMutation={commentUpdate}
            deleteMutation={commentDelete}
          />
        ))}
      </div>
      {comments.length === 0 && (
        <div className="flex-1 flex-align-center">
          <div className="flex-col flex-item-center">
            <span className="icon-message-gray"></span>
            <p className="c-6 mt24">아직 작성한 댓글이 없습니다. </p>
          </div>
        </div>
      )}
      <CommentModal ntcAtclId={ntcAtclId} registMutation={commentRegist} />
    </>
  )
}

export default Element
